// constants
import {
    HIRING_EIGHTEEN_DEPOSITS,
    HIRING_MAIN_DEPOSITS_WITH_NEWBALANCE,
    HIRING_MAIN_DEPOSITS_WITHOUT_NEWBALANCE,
    DEPOSIT_INFORMATIVE_WITHOUT_NEW_BALANCE,
    PAYROLL_BONIFIED_DEPOSIT_WITHOUT_MONEY,
} from 'constants/flagBasedFeatures'
import { BANNER_DEPOSIT_PAYROLL_ID, BANNER_DEPOSIT_WITHOUT_NEW_BALANCE_ID } from '../../components/deposits/constants/depositsConstants';

const DEPOSITS_PRODUCT_BANNERS = [
    {
        id: BANNER_DEPOSIT_PAYROLL_ID,
        featureFlag: PAYROLL_BONIFIED_DEPOSIT_WITHOUT_MONEY,
        title: __CONTACT_CENTER__ ? 'bannerBonifiedWithoutNewBalance-bannerBonifiedWithoutNewBalance_titleCC' : 'bannerBonifiedWithoutNewBalance-bannerBonifiedWithoutNewBalance_title',
        sidebarImgAlt: "bannerBonifiedWithoutNewBalance-bannerBonifiedWithoutNewBalance_title",
        sidebarImgUrl: 'https://www.openbank.es/assets/static/private-assets/images/commercial-banners/deposit_bonified_open.jpg',
        sidebarImgUrlByCountry: {
            "de": 'https://www.openbank.de/assets/static/private-assets/images/commercial-banners/deposit_bonified_open.jpg',
            "nl": 'https://www.openbank.nl/assets/static/private-assets/images/commercial-banners/deposit_bonified_open.jpg',
            "es": 'https://www.openbank.es/assets/static/private-assets/images/commercial-banners/deposit_bonified_open.jpg',
            "pt": 'https://www.openbank.pt/assets/static/private-assets/images/commercial-banners/deposit_bonified_open.jpg'
        },
        subtitle: 'bannerBonifiedWithoutNewBalance-bannerBonifiedWithoutNewBalance_subtitle',
        advantages: [
            {
                text: 'bannerBonifiedWithoutNewBalance-bannerBonifiedWithoutNewBalance_advantage01',
                icon: "bannerBonifiedWithoutNewBalance-bannerBonifiedWithoutNewBalance_advantage01_icon"
            },
            {
                text: 'bannerBonifiedWithoutNewBalance-bannerBonifiedWithoutNewBalance_advantage02',
                icon: 'bannerBonifiedWithoutNewBalance-bannerBonifiedWithoutNewBalance_advantage02_icon'
            },
            {
                text: 'bannerBonifiedWithoutNewBalance-bannerBonifiedWithoutNewBalance_advantage03',
                icon: 'bannerBonifiedWithoutNewBalance-bannerBonifiedWithoutNewBalance_advantage03_icon'
            },
            {
                text: 'bannerBonifiedWithoutNewBalance-bannerBonifiedWithoutNewBalance_advantage04',
                icon: 'bannerBonifiedWithoutNewBalance-bannerBonifiedWithoutNewBalance_advantage04_icon'
            },
        ],
        link: '/myprofile/purchase/depositpayroll'
    },
    {
        id: 'depo_eightteen',
        featureFlag: HIRING_EIGHTEEN_DEPOSITS,
        title: 'bannerDeposit18-title',
        sidebarImgAlt: "bannerDeposit18-title",
        sidebarImgUrl: 'https://www.openbank.es/assets/static/private-assets/images/commercial-banners/deposito_open.jpg',
        subtitle: 'bannerDeposit18-subtitle',
        advantages: [
            {
                text: 'bannerDeposit18-advantage01',
                icon: 'icon-porcentaje'
            },
            {
                text: 'bannerDeposit18-advantage02',
                icon: 'icon-0-euro'
            },
            {
                text: 'bannerDeposit18-advantage03',
                icon: 'icon-rentabilidad'
            },
            {
                text: 'bannerDeposit18-advantage04',
                icon: 'icon-dinero'
            },
        ],
        link: '/myprofile/purchase/deposit-eighteen-months'
    },
    {
        id: 'depo_withNewBalance',
        featureFlag: HIRING_MAIN_DEPOSITS_WITH_NEWBALANCE,
        title: __CONTACT_CENTER__ ? 'bannerWithNewBalance-bannerWithNewBalance_titleCC' : 'bannerWithNewBalance-bannerWithNewBalance_title',
        sidebarImgAlt: "bannerWithNewBalance-bannerWithNewBalance_title",
        sidebarImgUrl: 'https://www.openbank.es/assets/static/private-assets/images/commercial-banners/depositnm_open.jpg',
        subtitle: 'bannerWithNewBalance-bannerWithNewBalance_subtitle',
        advantages: [
            {
                text: 'bannerWithNewBalance-bannerWithNewBalance_advantage01',
                icon: "bannerWithNewBalance-bannerWithNewBalance_advantage01_icon"
            },
            {
                text: 'bannerWithNewBalance-bannerWithNewBalance_advantage02',
                icon: 'bannerWithNewBalance-bannerWithNewBalance_advantage02_icon'
            },
            {
                text: 'bannerWithNewBalance-bannerWithNewBalance_advantage03',
                icon: 'bannerWithNewBalance-bannerWithNewBalance_advantage03_icon'
            },
            {
                text: 'bannerWithNewBalance-bannerWithNewBalance_advantage04',
                icon: 'bannerWithNewBalance-bannerWithNewBalance_advantage04_icon'
            },
        ],
        link: '/myprofile/purchase/depositnm'
    },
    {
        id: BANNER_DEPOSIT_WITHOUT_NEW_BALANCE_ID,
        featureFlag: HIRING_MAIN_DEPOSITS_WITHOUT_NEWBALANCE,
        title: __CONTACT_CENTER__ ? 'bannerWithoutNewBalance-bannerWithoutNewBalance_titleCC' : 'bannerWithoutNewBalance-bannerWithoutNewBalance_title',
        sidebarImgAlt: "bannerWithoutNewBalance-bannerWithoutNewBalance_title",
        sidebarImgUrl: 'https://www.openbank.es/assets/static/private-assets/images/commercial-banners/deposit_open.jpg',
        subtitle: 'bannerWithoutNewBalance-bannerWithoutNewBalance_subtitle',
        advantages: [
            {
                text: 'bannerWithoutNewBalance-bannerWithoutNewBalance_advantage01',
                icon: 'bannerWithoutNewBalance-bannerWithoutNewBalance_advantage01_icon'
            },
            {
                text: 'bannerWithoutNewBalance-bannerWithoutNewBalance_advantage02',
                icon: 'bannerWithoutNewBalance-bannerWithoutNewBalance_advantage02_icon'
            },
            {
                text: 'bannerWithoutNewBalance-bannerWithoutNewBalance_advantage03',
                icon: 'bannerWithoutNewBalance-bannerWithoutNewBalance_advantage03_icon'
            },
            {
                text: 'bannerWithoutNewBalance-bannerWithoutNewBalance_advantage04',
                icon: 'bannerWithoutNewBalance-bannerWithoutNewBalance_advantage04_icon'
            },
        ],
        link: '/myprofile/purchase/deposit'
    },
    {
        id: 'depo_withoutNewBalanceInformative',
        featureFlag: DEPOSIT_INFORMATIVE_WITHOUT_NEW_BALANCE,
        title: 'bannerWithoutNewBalanceInformative-bannerWithoutNewBalanceInformative_title',
        sidebarImgAlt: "bannerWithoutNewBalanceInformative-bannerWithoutNewBalanceInformative_title",
        sidebarImgUrl: 'https://www.openbank.es/assets/static/private-assets/images/informative-banners/deposit_open_retention.jpg',
        subtitle: 'bannerWithoutNewBalanceInformative-bannerWithoutNewBalanceInformative_subtitle',
        type: 'deposits-informative',
        informativeText: 'bannerWithoutNewBalanceInformative-bannerWithoutNewBalanceInformative_informativeText'
    },
];

module.exports = DEPOSITS_PRODUCT_BANNERS;
